import { type MantineColorScheme } from '@mantine/core'

import { ACCOUNT_LOGO_CONFIG, DATAGROUP_LOGO_CONFIG } from './constants'
import { type AccountWithLogo } from './types'

export const getAccountLogoSrc = (account: string, colorScheme: MantineColorScheme) => {
  if (!account) {
    return null
  }

  return colorScheme === 'light'
    ? `/assets/images/logos/${account}-light.svg`
    : `/assets/images/logos/${account}-dark.svg`
}

export const hasAccountLogo = (account?: string): account is AccountWithLogo =>
  !!account && Object.hasOwn(ACCOUNT_LOGO_CONFIG, account)

export const getDatagroupLogo = (account?: string, datagroupId?: string) => {
  if (!hasAccountLogo(account) || !datagroupId) {
    return undefined
  }

  const datagroupLogos = DATAGROUP_LOGO_CONFIG[account]

  if (!datagroupLogos || !Object.hasOwn(datagroupLogos, datagroupId)) {
    return undefined
  }

  return datagroupLogos[datagroupId]
}
